import { render, staticRenderFns } from "./SimulationsList.vue?vue&type=template&id=87b002ba&"
import script from "./SimulationsList.vue?vue&type=script&lang=js&"
export * from "./SimulationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports